import axiosClient from "utils/api";

export const uploadFile = async (payload) => {
  const URL = `/upload/file`;
  let tempObj = new FormData();
  const filesArray = Array.from(payload?.file);

  filesArray.forEach((file) => {
    tempObj.append("file", file);
  });

  tempObj.append("uploadFor", payload.uploadFor);
  
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: tempObj,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during upload file:", error);
    throw error;
  }
};
